/* unplugin-vue-components disabled */import { render } from "./normal.vue?vue&type=template&id=6bd271ed&scoped=true&ts=true"
import script from "./normal.vue?vue&type=script&lang=ts"
export * from "./normal.vue?vue&type=script&lang=ts"

import "./normal.vue?vue&type=style&index=0&id=6bd271ed&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd271ed"]])

export default __exports__